import React from "react";
import i18n from "../../constants/i18n";
import { ImageControlInput } from "./ImageControlInput";
import { useUpdateImageControl } from "./hooks/useUpdateImageControl";

interface BlockImageControlContainerProps {
    hideModal: () => void;
    blockId: number;
    ceremonyId: number;
    manualImageControl: boolean;
    onImageControlChanged: () => void;
}

export function BlockImageControlContainer(
    props: BlockImageControlContainerProps
) {
    const [selectedOption, setSelectedOption] = React.useState(
        props.manualImageControl ? "manual" : "automatic"
    );
    const update = useUpdateImageControl(props.ceremonyId, props.blockId);

    async function onSubmit() {
        update.mutate(
            {
                manualImageControl: selectedOption === "manual",
            },
            {
                onSuccess: () => {
                    props.onImageControlChanged();
                },
            }
        );
    }

    return (
        <>
            <header className="modal-card-head">
                <h2 className="modal-card-title has-text-primary">
                    {i18n.imageControlModal.title}
                </h2>
                <button
                    onClick={props.hideModal}
                    className="delete"
                    aria-label="close"
                />
            </header>
            <section className="modal-card-body">
                <ImageControlInput
                    selectedOption={selectedOption}
                    handleChange={setSelectedOption}
                />
            </section>
            <footer className="modal-card-foot">
                <button
                    className="button is-primary is-rounded"
                    onClick={onSubmit}
                >
                    Opslaan
                </button>
            </footer>
        </>
    );
}
